<template>
  <b-card
    class="offer"
  >
    <table>
      <tr>
        <th>Proto</th>
        <td>{{offer.protoId | getProtoAlias}}</td>
      </tr>
      <tr>
        <th>State</th>
        <td>{{offer.state | getOfferStateName}}</td>
      </tr>
      <tr>
        <th>Start</th>
        <td>{{offer.startStamp | getMomentStr}}</td>
      </tr>
      <tr>
        <th>Finish</th>
        <td>{{offer.finishStamp | getOptionalTextMomentStr('not finished')}}</td>
      </tr>
    </table>

    <template v-if="hasPayments">
      <offer-payment
        v-for="payment in offer.payments"
        :key="payment.sku"
        :payment="payment"
      />
    </template>

  </b-card>
</template>

<script>
import OfferPayment from './PlayerOfferPayment.vue';

export default {
  name: 'PlayerOfferPersonal',

  components: {
    OfferPayment,
  },

  props: {
    offer: {
      type: Object,
      required: true,
    },
  },

  computed: {
    hasPayments() {
      if(this.offer === null) {
        return false;
      }
      if(!('payments' in this.offer)) {
        return false;
      }
      return this.offer.payments.length > 0;
    },
  },
};
</script>
